module.exports = __webpack_public_path__ + "static/isthi-b728532d88becd269e4c891dfeeafcd7.png";